// extracted by mini-css-extract-plugin
module.exports = {"component":"room-matrix-headline_component__nEhth","link":"room-matrix-headline_link__fCXIU","loader":"room-matrix-headline_loader__4_dk_"};